import React from 'react';
import { useTranslation } from 'react-i18next';
import { InputTextProps } from './Types';
import { useCommonSelector } from '@wajeez-web/stores/common';
import InputLabel from './InputLabel';
const TextInput = React.forwardRef<HTMLInputElement, InputTextProps>(
  (
    {
      label,
      shape = 'squre',
      color = 'textPrimary',
      bg = 'white',
      onChange,
      name,
      prefix,
      suffix,
      required = false,
      value,
      placeholder = '',
      size,
      disabled,
      onClick,
      classNamesInputExtra,
      isControlled = false,
    },
    ref
  ) => {
    const { dir } = useCommonSelector((state) => state.common.settings);
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
      onChange(name, e.target.value, e);
    };

    const { t } = useTranslation();

    return (
      <div>
        {label && (
          <InputLabel
            text={t(`inputs.labels.${label}`, label.toString() || '') as string}
            name={name}
            required={required}
          />
        )}
        <div
          className={`relative ${
            shape === 'circle' ? 'rounded-full' : 'rounded-md'
          } shadow-sm`}
        >
          {prefix && (
            <div
              className={`absolute inset-y-0 ltr:left-0 rtl:right-0  ps-3 flex items-center pointer-events-none`}
            >
              <span className="text-gray-500 sm:text-sm">{prefix}</span>
            </div>
          )}
          <input
            ref={ref}
            type="text"
            onKeyUp={onClick ? onClick : undefined}
            name={name}
            disabled={disabled}
            id={name}
            autoComplete="off"
            required={required}
            value={isControlled ? value || '' : value}
            onChange={handleChange}
            className={`input focus:ring-opacity-0 focus:ring-ring-color py-1 lg:py-2  focus:ring-4 cursor-pointer   focus:ring-offset-0  ${
              shape === 'circle' ? 'rounded-full' : 'rounded-md'
            } bg-${bg} text-${color} focus:border-primary block w-full ${
              prefix && dir === 'rtl' ? 'pr-7' : 'pl-7'
            } sm:text-sm border-gray-300 ${classNamesInputExtra}`}
            placeholder={`${t(
              `inputs.placeholders.${placeholder}`,
              placeholder || ''
            )}${!label && required ? '*' : ''}`}
          />
          <div
            className={`absolute inset-y-0 ltr:right-1 rtl:left-1 flex items-center`}
          >
            {suffix}
          </div>
        </div>
      </div>
    );
  }
);

export default TextInput;
